import React from 'react';
import Certificates from './CertificatesApp';

const CertificatesEntry = () => {
  return <Certificates />;
};

export default CertificatesEntry;
